import axios from "axios";
import $ from "jquery";
import { capitalize, flattenDepth, has, isEmpty, isNull, map, round } from "lodash";
import MaterialTable from "material-table";
import moment from "moment";
import "rc-slider/assets/index.css";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import Navigation from "../components/navigation/Header";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      presentCategory: [],
      authName: "",
      previousAssessments: [],
      assessmentTypes: [],
      selectedAssessmentType: "",
      hasPreviousAssessmentFlag: "none",
      startBtnDisabled: true,
      popoverOpen: false,

      assessment_Id: "",
      questions: [],
      questions_data: [],
      result: [],
      assessmentResponse: [],
      displayCoupleMessage: false,
      subscription_status: 0,
      popupMessage: `You must select an assessment type from the list above
      before clicking start.`,
    };
    // this.url = "http://localhost:33333";
    this.url = `${process.env.REACT_APP_API_IP}`;
  }
  componentWillMount = () => {
    let uri = this.url + "/assessment/assessment-types";
    axios
      .post(uri, {
        authToken: this.props.authToken,
      })
      .then((response) => {
        if (response.data.length != 0) {
          this.setState({
            assessmentTypes: response.data,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  componentDidMount = () => {
    $(".assessment-worship-top").hide();

    let uricategories = this.url + "/domains/categories";

    axios
      .post(uricategories, { authToken: this.props.authToken })
      .then((response) => {
        if (response.data.length != 0) {
          let dummyResponse = response.data;
          let z = map(dummyResponse, (m) => {
            // m = { ...m, ... isFetching: true}
            m = { ...{ ["isFetching"]: false, ["message"]: "" }, ...m };
            return m;
          });
          localStorage["categories"] = JSON.stringify(z);
          sessionStorage["categories"] = JSON.stringify(z);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    let state = localStorage["appState"];
    if (state) {
      let AppState = JSON.parse(state);

      if (AppState.subscription_status != 1) {
        this.setState({
          popupMessage: "Your subscription has expired.",
        });
      }

      this.setState({
        authName: AppState.first_name + " " + AppState.last_name,
        subscription_status: AppState.subscription_status,
      });

      const postData = {
        id: AppState.user,
        authToken: this.props.authToken,
      };

      const options = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        },
      };

      let uri = this.url + "/assessment/check-assessment";

      axios.post(uri, postData, options).then((response) => {
        if (response.data.data != undefined && response.data.data.length != 0) {
          this.setState({
            previousAssessments: response.data.data,
            hasPreviousAssessmentFlag: "inline-block",
          });
        } else {
        }
      });
    }
  };
  getPreviousAssessments() {
    let state = localStorage["appState"];
    if (state) {
      let AppState = JSON.parse(state);
      this.setState({
        authName: AppState.first_name + " " + AppState.last_name,
      });

      const postData = {
        id: AppState.user,
        authToken: this.props.authToken,
      };

      const options = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        },
      };

      let uri = this.url + "/assessment/check-assessment";

      axios.post(uri, postData, options).then((response) => {
        if (response.data.data.length != 0) {
          this.setState({
            previousAssessments: response.data.data,
            hasPreviousAssessmentFlag: "inline-block",
          });
        } else {
        }
      });
    }
  }
  deleteAssessment = (id) => {
    const postData = {
      id: id,
      authToken: this.props.authToken,
    };

    const options = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      },
    };

    let uri = this.url + "/assessment/remove-assessment";

    axios.post(uri, postData, options).then((response) => {
      this.getPreviousAssessments();
    });
  };
  viewPreviousAssessments = () => {};

  handleChangeAssessmentType = (e) => {
    sessionStorage["templateId"] = e.target.value;
    this.setState({
      selectedAssessmentType: e.target.value,
    });
    if (e.target.value == "") {
      this.setState({
        startBtnDisabled: true,
        popupMessage: `You must select an assessment type from the list above
      before clicking start.`,
      });
    } else {
      this.setState({
        startBtnDisabled: false,
        popupMessage: `You must select an assessment type from the list above
      before clicking start.`,
      });
    }

    if (this.state.subscription_status !== 1) {
      this.setState({
        startBtnDisabled: true,
        popupMessage: "Your subscription has expired.",
      });
    }
  };

  displayResult = (assesstment) => {
    let uri = this.url + "/assessment/getResults";
    let uriresponse = this.url + "/assessment/get-assessment-response-id";
    const options = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      },
    };
    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);
    const postData = {
      user_id: AppStateCall.user,
      template: assesstment.Template,
      assessment_id: assesstment.ID,
      authToken: this.props.authToken,
    };

    let scores = null;
    axios.post(uri, postData, options).then((response) => {
      if (response.status == 200) {
        if (response.data.message == "Couple did not complete assessment") {
          this.setState({
            popupMessage: `You will see a
            feedback report after your spouse has completed a Couples
            Assessment within the next 30 days.`,
            displayCoupleMessage: true,
            popoverOpen: true,
          });
        } else if (response.data.message == "Assessment Response Get") {
          let dummyVariable = this.state.questions;
          let rdata = response.data.data;
          let z = Object.keys(response.data.data);
          let ddata = [];
          z.map((key, index) => {
            ddata.push(rdata[Object.keys(rdata)[index]]);
          });
          let rdata1 = ddata;
          let dataWithKey;
          if (Object.keys(rdata).length) {
            dataWithKey = rdata1.map((row1) => {
              return row1.map((m) => {
                return m;
              });
            });
          }

          let dataWithKeyIndex = new Array([].concat(...dataWithKey));

          dummyVariable.push(dataWithKeyIndex[0]);

          let array = dummyVariable;
          let mergedArrays = new Array([].concat(...array));
          let obj = mergedArrays[0];

          var holder = {};
          var notesholder = {};

          let tempScoresObject = obj;

          if (assesstment.Template == 2) {
            for (let i = 0; i < obj.length; i++) {
              let couple_note = null;
              let couple_note_title = null;
              let special_note = null;

              for (let j = 0; j < obj[i].answers.length; j++) {
                if (obj[i].selectedAnswer.Score <= obj[i].answers[j].Score || (Number(obj[i].selectedAnswer.CoupleScore) <= obj[i].answers[j].Score && couple_note == null)) {
                  couple_note = obj[i].answers[j].Note;
                  couple_note_title = obj[i].answers[j].Note_title;
                  special_note = obj[i].answers[j].Special_note;
                  break;
                }
              }

              //Set Average Scores
              obj[i].selectedAnswer = {
                ...obj[i].selectedAnswer,
                Score: (obj[i].selectedAnswer.Score + Number(obj[i].selectedAnswer.CoupleScore)) / 2,
                Note: couple_note,
                Note_title: couple_note_title,
                Special_note: special_note,
              };
            }
          } else if (assesstment.Template == 1) {
            for (let i = 0; i < obj.length; i++) {
              let note = null;
              let note_title = null;
              let special_note = null;

              for (let j = 0; j < obj[i].answers.length; j++) {
                if (obj[i].selectedAnswer.Score <= obj[i].answers[j].Score && note == null) {
                  note = obj[i].answers[j].Note;
                  note_title = obj[i].answers[j].Note_title;
                  special_note = obj[i].answers[j].Special_note;
                  break;
                }
              }

              //Set Notes
              obj[i].selectedAnswer = {
                ...obj[i].selectedAnswer,
                Note: note,
                Note_title: note_title,
                Special_note: special_note,
              };
            }
          }

          obj.forEach(function (d, i) {
            if (notesholder.hasOwnProperty(d.Question_Category)) {
              let dummy = notesholder[d.Question_Category];

              let note = "";
              let note_title = "";

              dummy.push(
                d.Question_type != 1
                  ? {
                      note: d.Note,
                      title: d.Note_title,
                      toDisplay: assesstment.Template == 1 ? d.selectedAnswer.Score >= d.Special_note_min && d.selectedAnswer.Score <= d.Special_note_max : (d.selectedAnswer.ScoreFirstPersonCouple >= d.Special_note_min && d.selectedAnswer.ScoreFirstPersonCouple <= d.Special_note_max) || (d.selectedAnswer.CoupleScore >= d.Special_note_min && d.selectedAnswer.CoupleScore <= d.Special_note_max),
                    }
                  : {
                      note: d.selectedAnswer.Note,
                      title: d.selectedAnswer.Note_title,
                      toDisplay: !isNull(d.selectedAnswer.Special_note),
                    },
              );
              notesholder[d.Question_Category] = dummy;
            } else {
              notesholder[d.Question_Category] = [
                d.Question_type != 1
                  ? {
                      note: d.Note,
                      title: d.Note_title,
                      toDisplay: assesstment.Template == 1 ? d.selectedAnswer.Score >= d.Special_note_min && d.selectedAnswer.Score <= d.Special_note_max : (d.selectedAnswer.Score >= d.Special_note_min && d.selectedAnswer.Score <= d.Special_note_max) || (d.selectedAnswer.CoupleScore >= d.Special_note_min && d.selectedAnswer.CoupleScore <= d.Special_note_max),
                    }
                  : {
                      note: d.selectedAnswer.Note,
                      title: d.selectedAnswer.Note_title,
                      toDisplay: !isNull(d.selectedAnswer.Special_note),
                    },
              ];
            }

            if (holder.hasOwnProperty(d.Question_Category)) {
              d.Question_type != 4
                ? (holder[d.Question_Category] = holder[d.Question_Category] + d.selectedAnswer.Score)
                : "array" in holder
                ? (holder["array"] = holder[array][d.Question_Category].push(d.selectedAnswer.Score))
                : (holder["array"] = {
                    [d.Question_Category]: [d.selectedAnswer.Score],
                  });
            } else {
              d.Question_type != 4
                ? (holder[d.Question_Category] = d.selectedAnswer.Score)
                : (holder["array"] = {
                    [d.Question_Category]: [d.selectedAnswer.Score],
                  });
            }
          });
          var obj2 = [];
          for (var prop in holder) {
            obj2.push({
              Question_Category: prop,
              notes: notesholder,
              Score: has(holder.array, prop) ? round(holder[prop] / flattenDepth(array, 5).filter((obj) => obj.Question_Category === prop && obj.Question_type != 4).length, 2) * 0.1 * (holder["array"][prop][0] > 10 ? 10 : holder["array"][prop][0]) : round(holder[prop] / flattenDepth(array, 5).filter((obj) => obj.Question_Category === prop).length, 2),
            });
          }

          this.setState({
            result: obj2,
          });

          sessionStorage["templateId"] = assesstment.Template;

          this.props.history.push("/result", {
            result: this.state.result.filter((item) => item.Question_Category != "array"),
            assessment_Id: this.state.assessment_Id,
            date_completed: assesstment.Date_completed,
          });
        }
      }
    });
  };

  start = () => {
    this.props.history.push("/Assessment");
  };

  render() {
    return (
      <div>
        <Navigation {...this.props} />

        <div className="height">
          <section className="main-content">
            <h2 className="heading1 welcome-title text-center">Welcome {this.state.authName}!</h2>

            <br />
            <div className="row rowSeparator">
              <div className="col-lg-6">
                <div className="card-content">
                  <h3>Spiritual Health Assessment</h3>

                  <p>The Essential Faith Project assists churches and Christian organizations in making, assessing and strengthening disciples of Jesus. Our primary tool is our Spiritual Health Assessment which profiles person’s level of spiritual well-being across 7 essential domains.</p>
                </div>
              </div>
              <div className="col-lg-6 ">
                <div className="card-btn">
                  <select className="form-control" onChange={(e) => this.handleChangeAssessmentType(e)}>
                    <option value="">Choose Assessment Type</option>
                    {this.state.assessmentTypes.map((type, i) => {
                      let state = localStorage["appState"];
                      let AppState = JSON.parse(state);
                      if (isNull(AppState.spouse_user_id)) {
                        if (type.Assessment_TypeID == 1)
                          return (
                            <option key={"k-" + i} value={1}>
                              {"Individual"}
                            </option>
                          );
                      } else {
                        return (
                          <option key={"k-" + i} value={type.ID}>
                            {type.Assessment_Type_Name}
                          </option>
                        );
                      }
                    })}
                  </select>
                  <span title="Select Assessment type to start">
                    <Link
                      id="Popover1"
                      title="Select Assessment type to start"
                      to={{
                        //pathname: "/Assessment",
                        state: {
                          assessmentType: this.state.selectedAssessmentType,
                        },
                      }}
                      className="btn cta-homebtn"
                      onClick={() =>
                        this.state.startBtnDisabled
                          ? this.state.subscription_status != 1
                            ? this.setState({
                                popoverOpen: !this.state.popoverOpen,
                                popupMessage: `Your subscription has expired.`,
                              })
                            : this.setState({
                                popoverOpen: !this.state.popoverOpen,
                                popupMessage: `You must select an assessment type from the list above
                              before clicking start.`,
                              })
                          : ((sessionStorage["selectedAssessmentType"] = "completed"), this.props.history.push("/Assessment"))
                      }
                      style={{}}
                    >
                      START
                    </Link>
                  </span>
                </div>
                <Modal isOpen={this.state.popoverOpen}>
                  <ModalBody>{this.state.popupMessage}</ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() =>
                        this.setState({
                          popoverOpen: !this.state.popoverOpen,
                          displayCoupleMessage: false,
                        })
                      }
                    >
                      Ok
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
            </div>

            <div>
              <MaterialTable
                columns={[
                  {
                    title: "Date Started",
                    field: "Date_created",
                    render: (rowData) => moment(rowData.Date_created).format("YYYY-MM-DD hh:mm"),
                    defaultSort: "desc",
                  },
                  {
                    title: "Date Completed",
                    field: "Date_completed",
                    render: (rowData) => (moment(rowData.Date_completed).isValid() ? moment(rowData.Date_completed).format("YYYY-MM-DD hh:mm") : "--"),
                  },
                  {
                    title: "Assessment Type",
                    field: "Template",
                    render: (rowData) => (isEmpty(this.state.assessmentTypes.find((object) => object.ID === rowData.Template)) ? "" : this.state.assessmentTypes.find((object) => object.ID === rowData.Template).Assessment_Type_Name),
                  },
                  {
                    title: "Status",
                    field: "Status",
                    render: (rowData) => (rowData.Status === "completed" ? capitalize(rowData.Status) : "In progress"),
                  },
                ]}
                data={this.state.previousAssessments}
                title="Assessment History"
                isLoading={isEmpty(this.state.assessmentTypes)}
                onRowClick={(event, rowData) => {
                  if (rowData.Status === "completed") {
                    sessionStorage["selectedAssessment"] = rowData.ID;
                    this.props.history.push("/CompletedAssessment");
                  } else {
                    sessionStorage["selectedAssessment"] = rowData.ID;
                    sessionStorage["selectedAssessmentType"] = "pending";
                    window.location.replace("/PendingAssessment");
                  }
                }}
                actions={[
                  (rowData) =>
                    rowData.Status === "completed"
                      ? {
                          icon: "assessment",
                          tooltip: "Result Card",
                          onClick: (event, rowData) => rowData.Status === "completed" && this.displayResult(rowData),
                          disabled: false,
                        }
                      : {
                          icon: "assessment",
                          tooltip: "You cannot open result card for in progress assessment",
                          disabled: true,
                        },
                ]}
                options={{
                  actionsColumnIndex: -1,
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    // backgroundColor: '#01579b',
                    color: "#3454d1",
                    fontWeight: "550",
                    onRowAdd: "none",
                  },
                }}
                editable={{
                  isDeletable: (rowData) => rowData.Status != "completed",
                  onRowDelete: (oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        this.deleteAssessment(oldData.ID);
                      }, 600);
                    }),
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: <h6>No Assessment taken yet.</h6>,
                  },
                }}
              />
            </div>
            <footer>
              <div className="container">
                <a href="# ">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAABHNCSVQICAgIfAhkiAAADexJREFUeF7tnXlwFFUawPuaM4GEHBwFAeRyYRMyEyHcRwgJuWcWJcritVol5aq7tQorcujIKoq6tW6Vq4W6a0mtK2YJkBMDSUAIGFgTMkkIchqQkEBmcs/RM9P9tt4MwWTIzHT365kMVeQ/6Pe+975ff/n6+77+XgfH7v/4lQDuV+n3hWP3BOAJC/IUUaPGP4hJqckAYDgGmOa25ksXbtY/aQr2exjkgHVEXFZSmkQ68huCIEIHwmQBa7Lbeh9vKKosxDAdG6yggxiwjojXpGyUSELf9QbPbre8oS+Y/xcMw0AwQg5SwABXaU9toijFDi7QaFtPbkPhkv9yGRvoMUEJWK2pfpOQKLbiGEZwAcIy9tra/XMe4jI20GOCDrBK8/3bpES5iStcCAxgGNt1q2ny5WNrfw40QF/rBRVgtab6HVIi34hhOOlr4+7XaXPbsobSVcf4zvP3+KABrNacepekZK9gOE4JUdpq7pjbWJr0g5C5/pwTFICdlkvJN2I4f8t1ugiW7Wu9enrMjZr1Zn/CEiJ72AFDn0tJFK8KcQv9CjMO27/OHJj7rBAA/p4zjIABrtac0vGJFoaCAVjmut3StqD+YMZ1f8MSIn+YAOsIlTbtVZJSvMUnWnBXELCMwWrqWnm2bIVeiPKBmDMMgHWEWrNqIylRes3QfCkPANth6jYs/7E8pcHX2OG8HmDAgFDlVG+gpMqdKEoDwHbS3YZFjeUp51DkBGJuAAHnkaqcmFdEgNvT19M+8/zh1BuBAIS6RqAA4yptNefagielAAbsLZcvjG87k9uOqnig5gcEsFpbvY2kFNtRlIJwrzWdiGhveqEPRU6g5/odsLNwQym24bjw4j4AbE/LlYvT7iXL7b+RfgWMmqE5szTAdnV3ts65VJlxGdH68Pic4y+TpHItjuPhGIZZWZY+0ms8t/3S8Wf85nL8Bvh2bWGD0PT3NtwOutuwGDVaiEs/tEyqiP4aw4mx7r9JAAMmh936V33B/DcQb+CQ0/0CWBS4LGMw9RhXoMa5cekV6dKQqH04hsk9AwSM3WbdoS+c/7rYkEUHLIpbYB1tlt6e9KbDSXUoCsdlfZchlYcXcckWAWAtvcZzEy8c/a0BZU33uaIChg80kpJvQXELLMvecph60+vLltaiKBqbcTRFrgw/yKeI5LCbP6srWPAcyrr+AoyrtdVbCVLxJlq0wLSb+zrTzpUlo8HNqUqRS0N5wXX6fJa5VrMvYVKQAXYVbri+oPS0eWi51t6uVahuYXbW8WyJbMR+XEBtGQDQVpOvGhc8gNfkkWpbzAbkwg3LGMy9hoXnDqdeRFEOwpXKR+zn4xYGrscC5lJtfsJ0lD2I6CJ0hCpnFXLhBgOgt6vzhho1zo3NqUqRSUIPCrFcV0iIAQfd/Za+eKmokYTAh5xoJUdLt7F1xqWjaMXy2JyjKXIpvweau6UBADpr8lVRGIaJ2iUkADC/phCPhRvAmluuXJyMmv7CUEwmDysU6hZc1gscFrMxp+lg8kEx3QOUxRsw36aQoTYMY86WKxcnIcPNLF8pVUSX4BgmFQoG9lTYLR3r6kuS9giV4W0eL8BCmkLuWhz6XOONWchuIftQqkw2psB7huYdGYRrM3c90VC67D/+gMvLglGaQvo3L1bhJjajPEumiMrDcVwhHAxgbNaex+qLl+4VLsP3TE4WLEZtAca5th7DctTCTWzm4UyZfHQ+jmMy3+p5fAIwNqvpsfriRX6Fy8mCb9cWYFVMUMeN6yHCtFt6ulNRk4hfZ1eskMuiDqL6XIet7yl94aJ/C79B3Gd6tWAxmkKg5VpMHemo6W9c5pGVMsWob1GiBQyDVTPT04GC69WCRYkWWEeb3WTKRC3cxGefzJLIlAdQ4drspsfqC0RwC1/o5LExsTNYAlM4DO3XL+Q+3+LJpoewYB2h1qZtQS7csMxNi6krualsxVnuv1B3j0RNf50uCoZi1u5HUR9o00rzokMjw14jJNQzOEmEuWQDFtgctQ6b9a2GhTmF8ATJQC3cAHNr2/cFTKymkPjsE6mUNKRUaPrbD9dGdz3RUIQWis08tHe6PDL8IEGRUz3p7zCbt+nL/rcD0/1yZmQQYFdWFF7iC6C36zAUo7sNC1GjBVHgAuCw2QxrGopWHkDRaXp5/pQRo0ZW4RTls9Jm6+nJbViiuXOc4Q5geFRq9Ljpt9xP8/DZGHz7293ZmoBauIE+l5IqD6BZLrDTVuOjjcXJ+/no4D52yuEvJ4ZHTjiFk8RYLnJYljVdv/jj2PZcV3vBHcCqjBMqShl6houQocaI1RQiSrQAAGOlDesai1d+I1QfOG/iVx+Pipw14xxBkGP4yGHMlsV1CzJODAasPaWlKLmguy1WU8isrMpkpTyiDCVagA80mjaubSxakccHyl1jd+mUCXMXX8NJMpKvHLuNfqp+btruQYDjNad+I5HI9/EVJlbhJjazMlOmiIRvf5EKN7S185HG4uWCDOWO7hBu4pIbOOGKFPj+2K3Wp+vnpX85GHDOSbVEGsLrXRjscuw2ts5GLtw4awvRe1HSX2coRnfn1hctzecLZNB4RLhQlsNiXaKfn141CPCY2btDxk+Pu0ngRAiXDcJQTIymkNjsilSZNBI+0AQXbiBcMdLfSfm7xkU+MLVBiFvoZwYY1mz6uXnsec2zvYMAw3/EZR/TymRhPn+9YGe5GE0hsRnlKTJldCFKyVGs9Pd2tPADThLRXAzM0xhbb9/jDYuzv+q/fleiMTtn1TapVKnzJACeibCaurJQ2/bF8LkQLm0zr20oXIh0jNYZ50aEn+Aainli47Ba3tNf7duM5eYyHgA7/xuPzzyWSkiVOoKQJOK46zgrAEwPy9h30zbz202lSW0odzk2+3iWXDYCubYgBlyYoSkiw77jkkR405mhrR/UNfduGgj3LhfhLmDq0q9jlKERDwBMau64eaFJjHNosdnfpcplYaWooZgYPndG2d5fhUaFleEUNVGowQDnrxH9sb6554/ucH0CFrqop3mipL8iRQsPVuY9qAyPqCBIcrxQPWGhh7HZPtXPTXvekwxObzSEbmDgvNk5VTkSSeg+tPQXY2mLcU1jyQre8frAvTgLN1HhR1DgYgBjGJvtn3WJq9Z74xMQwNAtyKRhSFUx+BCw0p3rGouTkNLfGRV540NGRVQTJDlBqOFAy2VpO4Trs1HQ74BFaQrBgN1qMTx5tmQl0qt1Z5w7eUoNygPtNtzPfVmutyhC6I29ax4MxeSKiAKkBxoADtra/mhjSQqSW5iQ93lE9PTJFwmCjBCqoPOBZqN3efO57rL9ZsFxWZUZUnkkp+ZnjzE3LNxYDY+glhwxEdJfuEcHTf9Dn5j2Ip8b5BfAzjMRIWO+RcnQnE0hIryJwHTLqQTNthacIEbzAeM+1lOc60umPwATD62ubcEJklOB2tMGGQf9yZkDib/3pYDX6wDg6tqKizhFTsEFtIn1y2as9Ht1V3sGZWhc9yU64NlZxzZKZGE70TrdAW00XpjcfDQXKWOcVZI3VjEhupUrjKHGOayWnXrz6a1Yks4hRI7ogB9aXVuDE2SCkM3csRjGdvrM/rnzUGTAubEV+zbIoka9L1SOw0rv1JurBcOF6/oD8CWc8PzmlYuyALAFNflqLZex3saoaw9/SZDUk0LkOH3umWubsfXr7ULm+y1MS3i49iyBk7NQNsUy9sra/XOSUWTAubOrinZIRoS+xlcOQ9Mf1s2tfgXD0T/ZKLoFqzQnP6IkIS/wVWrgeMAyRmOtfkJz8++sKHJmFu+OVcbEcP5ghzOJsNCf1M1LewnDcVE+1Sg64GlL8qLDRk9vxnFCiQLHTpvW64sWfooiA9u1S5KQOK0Dd/uw6FAyXRka/XldYrrX2gLf/YgOGG4gPufkdolUuRklg2OdHZmGRagnj2Z+uydBMW70SRzDPba7uuDCwk2az9pCUACGm0jQnv4Qp2QvcTnG6mnT8NVUX1974vlDq37iq9jA8XHl+SslEeF7MJKIuCseBsBqt1o/qp+fsRFlDU9z/WLB/YuptKf/RlKyPyBBBmxnX097rAifkCHijhdtpkIVTxA4MRK27DE0XdHXenXT5dXP3/IHXL+Eae4bVWm/30lRyj+jKAAA211TVT4eu7kx6L947a6nXy3YtRjAVZrTf6Ek8i2IkM01VeWj7zXIAQAMscKDi2lvkBIF0ilKAIC57ecrE1tOrzai3KxAzg0QYKjS/c96+f/GrskjVfZJWylK7rHvgssm4KEaswghHJe1UMcE0IL7t5pHqjUTX0d1F2IdC0MF6Gv+MAB2+WSVJn07Sck3I5U1RToH4gsSyvVhAuyKLtTaU+8TlOJPKHEyyzLNFtOthefK0pDqvigQvc0dRsCubYmRjDjs9Gd1BYmip7liQB92wFAJmFYTlPRFobULwLK9N1uPjLn+/csWMaCIKSMoAEOF1Jrqv5OU/AWhX6yiLcY5DSUrasSEI4asoAGM6i5os2FZQ2ny/T/z4Msq1NrqDwhS8TKf6AK+4u/oaJzyU+W6q77kB/p6UFlwv/J8C0Qsa6+v3TcnPtDwuKwXlICdBaL7fyyKy/1DGZNHqrQxWynK83EGKN3hsLxTd2DeFgwT5x0ayo6HmhukFty/VR0Rl5n8sEQe+oX76SfAMmabzfxcQ/GNPRj2y5kIsQGhygtywC71opfnhY4fGROP49RUQLA4a7NfobuMdedPaJxHpYL5554AHMwAfe3tPmBfhBCv/x9V7zCzjAeY1gAAAABJRU5ErkJggg=="
                    alt=""
                  />
                </a>
              </div>
            </footer>
          </section>
        </div>
      </div>
    );
  }
}
